export default "__VITE_ASSET__CqfgKJyR__"